import {
  LoadingStatus,
  SortDirection,
} from '../../../../utils/constants';
import {
  getCurrentFilterPresetList,
  loadColumnSettingConfiguration,
} from '../../../../services/ObjectConfiguration/ObjectConfiguration.service';
import { getUserRestriction, getUserCurrentPageName } from '../../../../services/AuthService/AuthService';
import { getUserTimezone } from '../../../../hooks/useAuth';

// Pages that support PetroHub global filter application
const PETRO_HUB_FILTER_PAGES = ['Orders', 'OrderRequest', 'Cylinders', 'samples'];

/**
 * Checks if a global filter exists and has valid values
 */
const hasValidGlobalFilter = (userGlobalFilterPetroHub) => {
  if (!Array.isArray(userGlobalFilterPetroHub) || userGlobalFilterPetroHub.length === 0) {
    return false;
  }

  const { Fields } = userGlobalFilterPetroHub[0];
  return (
    Fields
    && Array.isArray(Fields)
    && Fields.length > 0
    && Fields.some((f) => f.Value && f.Value.length > 0)
  );
};

/**
 * Determines if global filter should be applied for current page
 */
const shouldApplyGlobalFilter = (currentPageName, userGlobalFilterPetroHub) => (
  PETRO_HUB_FILTER_PAGES.includes(currentPageName)
    && hasValidGlobalFilter(userGlobalFilterPetroHub)
);

/**
 * Finds the default filter preset from the filter list
 */
const findDefaultFilterPreset = (filterList) => (Array.isArray(filterList) && filterList.length > 0
  ? filterList.find((x) => x.Default)
  : null);

export const loadGridColumnSettingStoreAction = async ({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns
}) => {
  const state = getState();
  const { loadingGridColumnStatus } = getStateSliceForSearchPage(state);
  const { username, assignedDivisions } = getUserRestriction(state.auth);
  // const { username, assignedDivisions } = state.auth.loginUser;

  if (
    loadingGridColumnStatus === LoadingStatus.Success
    || loadingGridColumnStatus === LoadingStatus.Loading
  ) {
    return;
  }

  dispatch(
    searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Loading)
  );
  try {
    const { visibleColumns, combineApplyingColumns } = await loadColumnSettingConfiguration({
      username, // Fixed for all the pages
      assignedDivisions,
      objectType: objectTypeGridColumns,
    });

    dispatch(searchPageSliceActions.updateVisibleGridColumns(visibleColumns));
    dispatch(searchPageSliceActions.updateMergedGridColumns(combineApplyingColumns));
    dispatch(
      searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Success)
    );
  } catch (error) {
    dispatch(
      searchPageSliceActions.updateLoadingColumnSettingStatus(LoadingStatus.Failed)
    );
  }
};

export const doSearchStoreAction = async ({
  dispatch, getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  searchParamBuilder,
  searchWithPaginationApi,
  postResultsProcessHandler
}) => {
  dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Loading));
  try {
    const state = getState();
    const { filter, tableInfo } = getStateSliceForSearchPage(state);
    const timezone = getUserTimezone(state);
    const searchParamData = {
      page: tableInfo.page + 1,
      pageSize: tableInfo.pageSize,
      sortBy: SortDirection.combineSortBy(
        tableInfo.sortColumn,
        tableInfo.sortDirection
      ),
      ...searchParamBuilder(filter, timezone),
    };

    const data = await searchWithPaginationApi(searchParamData);
    // console.log('Search results data:', data);
    const rowItems = data.Data;
    if (postResultsProcessHandler) {
      postResultsProcessHandler(rowItems);
    }
    dispatch(
      searchPageSliceActions.updateSearchResults({
        dataRowItems: rowItems,
        Count: data.Count,
      })
    );

    dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Success));
  } catch (error) {
    console.log(error);
    dispatch(searchPageSliceActions.updateLoadingStatus(LoadingStatus.Failed));
  }
};

export const loadSavedFilterStoreAction = async ({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeForSaveUserFilter
}) => {
  const state = getState();
  const { username, userGlobalFilterPetroHub } = getUserRestriction(state.auth);
  const { isSavedFilterLoaded } = getStateSliceForSearchPage(state);

  if (isSavedFilterLoaded) {
    return;
  }

  const currentPageName = getUserCurrentPageName();
  const currentSavedFilterList = await getCurrentFilterPresetList({
    objectType: objectTypeForSaveUserFilter,
    username,
  });

  dispatch(
    searchPageSliceActions.updateSavedFilterList(currentSavedFilterList)
  );

  // Apply global filter for PetroHub users if available
  if (shouldApplyGlobalFilter(currentPageName, userGlobalFilterPetroHub)) {
    const { Fields } = userGlobalFilterPetroHub[0];
    dispatch(searchPageSliceActions.applySavedFilter(Fields));
    return;
  }

  // Apply default filter preset if available
  const defaultFilterPreset = findDefaultFilterPreset(currentSavedFilterList);
  if (defaultFilterPreset) {
    const { Fields } = defaultFilterPreset;
    dispatch(searchPageSliceActions.applySavedFilter(Fields));
  }
};
